import {has} from './has'

export const get = (object, key, fallbackValue = '') => has(object, key) ? object[key] : fallbackValue;